import api from "../../infra/api";

class servSolicitacaoCompartilhamento {
    async listarCFiltros(codigoResp, pesquisaGeral) {
        let url = `/api/v1/SolicitacaoCompartilhamento?page=1&start=0&limit=999&fields=["CodigoVisual","Protocolo","QtdePontos","MotivoReprovacao","Situacao","CodigoCidade","CodigoOcupante","Ocupante.Id","Ocupante.Nome","NomeRepresentante","CpfRepresentante","CodigoResponsavelTecnico","PrazoAnalise","DataApresentacao","DataInicioInstalacao","Bairro","DataTerminoInstalacao","DataCadastro","PrazoAvisoInstalacao","DataAprovacao","Analise","Ocupante.Codigo","Id","TipoCabo"]&sort=[{"property":"CodigoVisual","direction":"DESC"}]&filter=[{"property":"CodigoResponsavelTecnico","value":"${codigoResp}","and":false}]`;

        if (pesquisaGeral.trim() !== "") {
            url = url.slice(0, -1);
            url += `,{"property":"Ocupante.Nome","operator":"containsall","value":"${pesquisaGeral}"},{"property":"NomeRepresentante","operator":"containsall","value":"${pesquisaGeral}","and":false},{"property":"CodigoVisual","value":"${pesquisaGeral}","and":false}]`;
        }

        const response = await api({
            method: "GET",
            url: url
        });

        return response.data;
    }

    async listarCFiltrosComCodigo(codigoResp, codigo) {
        let url = `/api/v1/SolicitacaoCompartilhamento?page=1&start=0&limit=999&fields=["CodigoVisual","Protocolo","EmailRepresentante","QtdePontos","MotivoReprovacao","Situacao","CodigoCidade","CodigoOcupante","Ocupante.Id","Ocupante.Nome","NomeRepresentante","CpfRepresentante","CodigoResponsavelTecnico","PrazoAnalise","DataApresentacao","DataInicioInstalacao","DataTerminoInstalacao","DataCadastro","PrazoAvisoInstalacao","DataAprovacao","Analise","Ocupante.Codigo","Id","TipoCabo","Bairro"]&sort=[{"property":"CodigoVisual","direction":"DESC"}]&filter=[{"property":"CodigoResponsavelTecnico","value":"${codigoResp}","and":false},{"property":"Id","value":"${codigo}"}]`;

        const response = await api({
            method: "GET",
            url: url
        });

        return response.data;
    };

    async listarCfeSituacaoOuData(codigoResp, pesquisaGeral, codigo, situacao, tipoDataFiltro, dataInicial, dataFinal) {
        let filter = this.retornaFilterDeAcordoComFiltros(codigoResp, pesquisaGeral, codigo, situacao, tipoDataFiltro, dataInicial, dataFinal);
        let url = filter.trim() === "" ?
            `/api/v1/SolicitacaoCompartilhamento?page=1&start=0&limit=999&fields=["CodigoVisual","Protocolo","EmailRepresentante","Situacao","QtdePontos","MotivoReprovacao","CodigoResponsavelTecnico","CodigoCidade","CodigoOcupante","Ocupante.Id","Ocupante.Nome","NomeRepresentante","CpfRepresentante","PrazoAnalise","DataApresentacao","DataCadastro","Bairro","DataInicioInstalacao","DataTerminoInstalacao","PrazoAvisoInstalacao","DataAprovacao","Analise","Ocupante.Codigo","Id","TipoCabo"]&sort=[{"property":"CodigoVisual","direction":"DESC"}]&filter=[{"property":"CodigoResponsavelTecnico","value":"${codigoResp}","and":false}]` :
            `/api/v1/SolicitacaoCompartilhamento?page=1&start=0&limit=999&fields=["CodigoVisual","Protocolo","EmailRepresentante","CodigoCidade","QtdePontos","MotivoReprovacao","Situacao","CodigoResponsavelTecnico","CodigoOcupante","Ocupante.Id","Ocupante.Nome","NomeRepresentante","CpfRepresentante","PrazoAnalise","DataApresentacao","DataCadastro","Bairro","PrazoAvisoInstalacao","DataInicioInstalacao","DataTerminoInstalacao","DataAprovacao","Analise","Ocupante.Codigo","Id","TipoCabo"]&sort=[{"property":"CodigoVisual","direction":"DESC"}]&filter=${filter}`;

        const response = await api({
            method: "GET",
            url: url
        });

        return response.data;
    }

    retornaFilterDeAcordoComFiltros(codigoResp, pesquisaGeral, codigo, situacao, tipoDataFiltro, dataInicial, dataFinal) {
        let temPesquisaGeral = pesquisaGeral.trim() !== "";

        if (temPesquisaGeral) {
            let filtroSituacaoDatas = this.handleFiltrosSituacaoOuDatas(codigoResp, codigo, situacao, tipoDataFiltro, dataInicial, dataFinal);
            let filtroFinal = "," + filtroSituacaoDatas.slice(1);

            return `[{"property":"Ocupante.Nome","operator":"containsall","value":"${pesquisaGeral}","and":false},{"property":"NomeRepresentante","operator":"containsall","value":"${pesquisaGeral}","and":false},{"property":"Analise","operator":"equal","value":"${pesquisaGeral}","and":false},{"property":"CodigoVisual","operator":"equal","value":"${pesquisaGeral}","and":false},{"property":"CodigoResponsavelTecnico","operator":"equal","value":${codigoResp},"and":true,"not":false}` + filtroFinal;
        } else {
            return this.handleFiltrosSituacaoOuDatas(codigoResp, codigo, situacao, tipoDataFiltro, dataInicial, dataFinal);
        }
    }

    handleFiltrosSituacaoOuDatas(codigoResp, codigo, situacao, tipoDataFiltro, dataInicial, dataFinal) {
        let temSituacaoInformada = situacao.length > 0;
        let temPeriodoInformado = (dataInicial && dataInicial.toLocaleDateString() !== "") && (dataFinal && dataFinal.toLocaleDateString() !== "");
        let arraySituacaoFormatada = JSON.stringify(situacao);
        let campoParaFiltrarData = this.getTipoDataFiltro(tipoDataFiltro);

        if (temSituacaoInformada && !temPeriodoInformado) {
            return `[{"property":"CodigoVisual","operator":"equal","value":"${codigo}","and":true,"not":false},{"property":"CodigoResponsavelTecnico","operator":"equal","value":"${codigoResp}","and":true,"not":false},{"property":"Situacao","operator":"in","value":${arraySituacaoFormatada},"and":true,"not":false}]`
        } else if (!temSituacaoInformada && temPeriodoInformado) {
            return `[{"property":"CodigoVisual","operator":"equal","value":"${codigo}","and":true,"not":false},{"property":"CodigoResponsavelTecnico","operator":"equal","value":"${codigoResp}","and":true,"not":false},{"property":"${campoParaFiltrarData}","operator":"greaterOrEqual","value":"${dataInicial.toLocaleDateString()}","and":true},{"property":"${campoParaFiltrarData}","operator":"lessOrEqual","value":"${dataFinal.toLocaleDateString()}","and":true}]`
        } else {
            return `[{"property":"CodigoVisual","operator":"equal","value":"${codigo}","and":true,"not":false},{"property":"CodigoResponsavelTecnico","operator":"equal","value":"${codigoResp}","and":true,"not":false},{"property":"Situacao","operator":"in","value":${arraySituacaoFormatada},"and":true,"not":false},{"property":"${campoParaFiltrarData}","operator":"greaterOrEqual","value":"${dataInicial ? dataInicial.toLocaleDateString() : "01/01/1900"}","and":true},{"property":"${campoParaFiltrarData}","operator":"lessOrEqual","value":"${dataFinal ? dataFinal.toLocaleDateString() : "01/01/1900"}","and":true}]`
        }
    }

    getTipoDataFiltro(tipoDataFiltro) {
        let campoParaFiltrarData;

        switch (tipoDataFiltro) {
            case "data-cadastro":
                campoParaFiltrarData = "DataCadastro";
                break;
            case "data-prazo-analise":
                campoParaFiltrarData = "DataPrazoAnalise";
                break;
            case "data-aprovacao":
                campoParaFiltrarData = "DataAprovacao";
                break;
            default:
                campoParaFiltrarData = "PrazoAvisoInstalacao";
                break;
        }

        return campoParaFiltrarData;
    }

    async RecuperarParaEditar(codigoSolCompartilhamento) {
        const response = await api({
            method: "GET",
            url: `api/v1/SolicitacaoCompartilhamento/${codigoSolCompartilhamento}?fields=["Id", "CodigoVisual", "Analise", "Situacao", "Protocolo", "CodigoResponsavelTecnico", "CodigoOcupante", "Usuario", "CodigoCidade", "CodigoBairro", "CodigoRegiao", "TipoCabo", "NomeRepresentante", "CpfRepresentante", "EmailRepresentante", "QtdePontos", "DataCadastro", "DataApresentacao", "PrazoAnalise", "PrazoAvisoInstalacao", "DataInicioInstalacao", "DataTerminoInstalacao", "DataAprovacao", "ParecerRepresentante", "DataParecerRepresentante", "ObservacaoRepresentante", "ParecerProjeto", "DataParecerProjeto", "ObservacaoProjeto", "ParecerDocumentos", "DataParecerDocumentos", "ObservacaoDocumentos", "ParecerInstalacao", "DataParecerInstalacao", "ObservacaoInstalacao", "MotivoReprovacao", "Cidades", "Bairros", "RespTecnico", "Ocupante"]`
        });

        return response.data;
    }

    async SugerirRepresentante(dto) {
        const response = await api({
            method: "GET",
            url: `api/v1/SolicitacaoCompartilhamento/SugerirRepresentante/${dto.CodigoResponsavelTecnico}/${dto.CodigoOcupante}`
        });

        return response.data;
    }

    async BuscarPontos(dto) {
        const response = await api({
            method: "POST",
            url: 'api/v1/SolicitacaoCompartilhamento/BuscarPontos',
            data: dto
        });

        return response.data;
    }

    async BuscarParametros() {
        const response = await api({
            method: "GET",
            url: '/api/v1/SolicitacaoCompartilhamentoParametros/BuscarParametros'
        });

        return response.data;
    }

    async inserir(
        Situacao,
        CodigoResponsavelTecnico,
        CodigoOcupante,
        CodigoCidade,
        Bairro,
        TipoCabo,
        NomeRepresentante,
        CpfRepresentante,
        EmailRepresentante,
        QtdePontos,
        CodigoBairro,
        CodigoRegiao
    ) {

        const response = await api({
            method: "POST",
            url: "api/v1/SolicitacaoCompartilhamento",
            headers: {
                "Content-Type": "application/json",
            },
            data: JSON.stringify({
                Situacao: Situacao,
                CodigoResponsavelTecnico: CodigoResponsavelTecnico,
                CodigoOcupante: CodigoOcupante,
                CodigoCidade: CodigoCidade,
                Bairro: Bairro,
                TipoCabo: TipoCabo,
                NomeRepresentante: NomeRepresentante,
                CpfRepresentante: CpfRepresentante,
                EmailRepresentante: EmailRepresentante,
                QtdePontos: QtdePontos,
                DataCadastro: new Date(),
                PrazoAvisoInstalacao: new Date(),
                DataInicioInstalacao: new Date(),
                CodigoBairro: CodigoBairro,
                CodigoRegiao: CodigoRegiao
            })
        });

        return response.data;
    }

    async editar(
        Id,
        Analise,
        Situacao,
        CodigoResponsavelTecnico,
        CodigoOcupante,
        CodigoCidade,
        Bairro,
        TipoCabo,
        NomeRepresentante,
        CpfRepresentante,
        EmailRepresentante,
        DataInicioInstalacao,
        QtdePontos,
        CodigoBairro,
        CodigoRegiao
    ) {

        const response = await api({
            method: "PUT",
            url: "api/v1/SolicitacaoCompartilhamento",
            headers: {
                "Content-Type": "application/json",
            },
            data: JSON.stringify({
                CodigoSolicCompart: Id,
                Analise: Analise,
                Situacao: Situacao,
                CodigoResponsavelTecnico: CodigoResponsavelTecnico,
                CodigoOcupante: CodigoOcupante,
                CodigoCidade: CodigoCidade,
                Bairro: Bairro,
                TipoCabo: TipoCabo,
                NomeRepresentante: NomeRepresentante,
                CpfRepresentante: CpfRepresentante,
                EmailRepresentante: EmailRepresentante,
                QtdePontos: QtdePontos,
                MotivoReprovacao: "",
                DataInicioInstalacao: DataInicioInstalacao,
                CodigoBairro: CodigoBairro,
                CodigoRegiao: CodigoRegiao
            })
        });

        return response.data;
    }

    async SolicitarAnalise(dto) {
        const response = await api({
            method: "PUT",
            url: `api/v1/SolicitacaoCompartilhamento/SolicitarAnalise/${dto.id}`,
            data: {
                "EnviarEmailSolicCompartilhamento": dto.enviaEmail
            }
        });

        return response.data;
    }

    async LiberarInstalacao(dto) {
        const response = await api({
            method: "POST",
            url: `api/v1/SolicitacaoCompartilhamento/LiberarInstalacao/${dto.id}`,
            data: {
                "EnviarEmailSolicCompartilhamento": dto.enviaEmail
            }
        });

        return response.data;
    }

    async FinalizarAnalise(dto) {
        const response = await api({
            method: "POST",
            url: `api/v1/SolicitacaoCompartilhamento/FinalizarAnalise/${dto.id}`,
            data: {
                "EnviarEmailSolicCompartilhamento": dto.enviaEmail
            }
        });

        return response.data;
    }

    async InformarInstalacao(dto) {
        const response = await api({
            method: "PUT",
            url: `api/v1/SolicitacaoCompartilhamento/InformarInstalacao/${dto.id}`,
            data: {
                DataTerminoInstalacao: dto.DataTerminoInstalacao
            }
        });

        return response.data;
    }


    async Cancelar(codigoSolicCompart) {
        const response = await api({
            method: "PUT",
            url: `/api/v1/SolicitacaoCompartilhamento/Cancelar/${codigoSolicCompart}`
        });

        return response.data;
    }
}

export default new servSolicitacaoCompartilhamento();